import { DeviceModel } from '@lmt/shared-types';
import { useClaims } from '../auth/operations';

export interface Option {
  value: number;
  displayValue: string;
}

export function useDeviceModels() {
  const claims = useClaims();
  return claims.permissions.developerMode
    ? [
        {
          value: DeviceModel.MiniScreen,
          displayValue: 'MiniScreen',
        },
        {
          value: DeviceModel.PTSLab,
          displayValue: 'pTSLab',
        },
      ]
    : [
        {
          value: DeviceModel.MiniScreen,
          displayValue: 'MiniScreen',
        },
      ];
}
